import { render, staticRenderFns } from "./FClientCreditorList.vue?vue&type=template&id=95de91e4&"
import script from "./FClientCreditorList.vue?vue&type=script&lang=ts&"
export * from "./FClientCreditorList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports